import { Component } from "@angular/core";

@Component({
	selector: "schedule-card",
	templateUrl: "./schedule-card.component.html",
	styleUrls: ["./schedule-card.component.scss"]
})
export class ScheduleCardComponent {}
